// var(--cds-spacing-200), which is 16px, is the left and right padding of the CDS grid
// when viewport is less than 1024px (sm).
export const CDS_GRID_PADDING = 16;

// var(--cds-spacing-600), which is 48px, is the left and right padding of the CDS grid
// when viewport is greater than 1024px (sm).
export const CDS_GRID_LARGE_PADDING = 48;
